import { render, staticRenderFns } from "./EditarVeiculo.vue?vue&type=template&id=953a9da4"
import script from "./EditarVeiculo.vue?vue&type=script&lang=js"
export * from "./EditarVeiculo.vue?vue&type=script&lang=js"
import style0 from "./EditarVeiculo.vue?vue&type=style&index=0&id=953a9da4&prod&scopped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports